export const type_need_keys = {
    edit_asset_device_type:['name', 'asset_device_type_id', 'desc', 'id']
}

export const staff_type_list = [
    {
        title: '正式员工',
        key: 0
    },
    {
        title: '大规模',
        key: 50
    },
    {
        title: '实习生',
        key: 10
    }
]